/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_History13Inputs */

const en__field__enum_studyprograms_study_history13 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_History13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`History`)
};

const de__field__enum_studyprograms_study_history13 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_History13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschichte`)
};

/**
* | output |
* | --- |
* | "History" |
*
* @param {_Field__Enum_Studyprograms_Study_History13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_history13 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_History13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_History13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_history13(inputs)
	return de__field__enum_studyprograms_study_history13(inputs)
});
export { _field__enum_studyprograms_study_history13 as "_field__enum_studyPrograms_STUDY_HISTORY" }